webpackJsonp([24,27,41],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = checkIntersection;
function checkIntersection($el, callback) {
  var $scrollListener = document.querySelector('.scroll-listener');
  var observerActive = false;

  function onScrollUpdate() {
    if (observerActive === false) {
      observerActive = true;

      setTimeout(function () {
        if ($el.getBoundingClientRect().top < window.innerHeight && $el.getBoundingClientRect().bottom >= 0 && $el.clientWidth > 0 && $el.clientHeight > 0) {
          callback();
          $scrollListener.Component['scroll-listener'].removeObserver(onScrollUpdate);
        }

        observerActive = false;
      }, 200);
    }
  }

  onScrollUpdate();

  $scrollListener.Component['scroll-listener'].addObserver(onScrollUpdate);
}

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__ = __webpack_require__(171);



/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initState: {
      isInView: false,
      imageIsLoaded: false
    },
    initFunction: function initFunction($el, params) {
      var $image = $el.querySelector('.' + nameSpace + '__image');

      //
      // Methods
      //

      //
      // Life Cycle
      //

      params.onStateUpdate(function (newState, prevState) {
        if (!prevState.isInView && newState.isInView) {
          __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 181)).then(function (module) {
            setTimeout(function () {
              if ($image.src) {
                params.setState({ imageIsLoaded: true });
              } else {
                $image.Component['block-img-load'].addObserver(function (state) {
                  return state.isLoaded && params.setState({ imageIsLoaded: true });
                });
                $image.Component['block-img-load'].setSrc();
              }
            }, 0);
          });
        }

        if (!prevState.imageIsLoaded && newState.imageIsLoaded) {
          new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 74)).then(function (module) {
            var $slide = module.default({
              el: $image,
              selector: '.' + nameSpace + '__image-wrapper'
            });
            $slide.classList.add(nameSpace + '__image-wrapper--is-loaded');
          });
        }
      });

      //
      // Procedures
      //

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__["default"])($el, function () {
        params.setState({ isInView: true });
      });

      //
      // Public API
      //

      return {};
    }
  });
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set_parent_when_loaded__ = __webpack_require__(182);



/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initFunction: function initFunction($el, params) {

      //
      // Methods
      //

      //
      // Life Cycle
      //

      //
      // Procedures
      //

      Object(__WEBPACK_IMPORTED_MODULE_1__set_parent_when_loaded__["default"])(nameSpace).init({
        $el: $el
      });

      //
      // Listeners / Observers
      //

      //
      // Public API
      //

      return {};
    }
  });
});

/***/ })

});


// WEBPACK FOOTER //
// js/chunk-article-card.bundle.js